import React, { Component } from "react";
import { Link } from "gatsby";

import Layout from "../components/layout"
import SEO from "../components/seo"

class NotFoundPage extends Component {
  render() {
    return (
      <Layout>
        <SEO title="404: Pas trouvé" />
        <div className="container container--pad" style={{padding: '6rem 0'}}>
          <h1 className="post__title has-text-centered">
            404<br />
            <span>Pas trouvé</span>
          </h1>
          <hr />
          <div className="content column has-text-centered">
            <p>Vous venez de choisir un chemin qui n'existe pas.</p>
            <Link to="/" className="button is-link is-light">
              Retour à la page d'accueil
            </Link>
          </div>
        </div>
      </Layout>
    );
  }
}

export default NotFoundPage
